import React from 'react';
import { Section } from './ui/Section';
export function HonestPromise() {
  return <Section className="py-20 bg-brand-bg" data-id="element-54">
      <div className="max-w-3xl mx-auto text-center px-6 py-12 bg-white rounded-3xl shadow-sm border border-brand-light relative overflow-hidden" data-id="element-55">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-accent via-brand-primary to-brand-accent" data-id="element-56"></div>

        <h2 className="text-2xl md:text-3xl font-serif mb-6 text-brand-text" data-id="element-57">
          Lo que podés esperar <br data-id="element-58" />
          <span className="text-brand-primary text-xl md:text-2xl italic" data-id="element-59">
            (promesa honesta)
          </span>
        </h2>

        <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-60">
          No te prometo “nunca más un sofoco”. <br data-id="element-61" />
          Te prometo algo más útil:
        </p>

        <div className="mt-8 p-6 bg-brand-light/50 rounded-xl" data-id="element-62">
          <p className="text-xl md:text-2xl font-serif font-medium text-brand-primary" data-id="element-63">
            Un plan simple para recuperar control, reducir reactividad y dejar
            de sentir que tu cuerpo decide por vos.
          </p>
        </div>
      </div>
    </Section>;
}